/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { I18n } from 'react-redux-i18n';

const CheckoutPaymentBilling = (props) => {
  const { selectedContract } = props;
  const type = 'billing';

  const paymentTerms = selectedContract.clientDetails && selectedContract.clientDetails.paymentTermsLabel
  && selectedContract.clientDetails.paymentTermsLabel.description;

  if (selectedContract) {
    return (
      <React.Fragment>
        <div className="basket-invoice">
          <div className="invoice">
            {paymentTerms && (
              <span className="txt">
                <strong>
                  {I18n.t('paymentTerm')}
                :
                </strong>
                &nbsp;
                {paymentTerms}
              </span>
            )}
            <button
              type="button"
              className="btn"
              onClick={() => props.setPayment(type)}
            >
              {I18n.t('billing')}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }

  return null;
};

export default CheckoutPaymentBilling;
